// const codeOfConductDoc = "./codeOfConduct.pdf";

export const playerDocuments = [
  // {
  //   documentName: "Player & Parent Agreement",
  //   documentLink: "https://drive.google.com/file/d/1ev0JsHk2Fbo9jcDfh94cNgZV5MQFeJ3C/view?usp=sharing",
  // },
  {
    documentName: "Player Code of Conduct",
    documentLink: "https://drive.google.com/file/d/1uDXUHmtc32YdsmZGcWbP_0f_H8NjzTV4/view?usp=sharing",
  },
  {
    documentName: "Team Letter",
    documentLink: "https://drive.google.com/file/d/1ayWYgnUScPaMwrt2WWTDf1s7jjbXlbgL/view?usp=sharing",
  },
  {
    documentName: "News Letter",
    documentLink: "https://drive.google.com/file/d/1SzaBkQKNeNqTLXmlCRMtxJl42HGjocI7/view?usp=drive_link",
  },
];
